/**
 * @generated SignedSource<<51682ce333ed3e8dce8ffb54e4c74eec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CommentActionsReadReactionsSummaryFragment$data = {
  readonly ari: string;
  readonly containerAri: string;
  readonly reactionsCount: number;
  readonly reactionsSummaryForEmoji: ReadonlyArray<{
    readonly count: number;
    readonly emojiId: string;
    readonly id: string;
    readonly reacted: boolean;
  } | null>;
  readonly " $fragmentType": "CommentActionsReadReactionsSummaryFragment";
};
export type CommentActionsReadReactionsSummaryFragment$key = {
  readonly " $data"?: CommentActionsReadReactionsSummaryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentActionsReadReactionsSummaryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "CommentActionsReadReactionsSummaryFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "kind": "ScalarField",
          "name": "reacted"
        }
      ]
    }
  ],
  "type": "ReactionsSummaryResponse"
};

(node as any).hash = "e36b984d531a5ed453a45170e33f0598";

export default node;
